export default [
  'rightFrontLeft',
  'rightBackLeft',
  'rightBackRight',
  'rightFrontRight',
  'leftFrontLeft',
  'leftBackLeft',
  'leftBackRight',
  'leftFrontRight',
  'trustrengthRaw',
];
